import { z } from 'zod';
import { esDiaValido } from '../fechas';

export const uuid = z.string().uuid();
export const dia = z.string().refine(esDiaValido, 'Fecha inválida (YYYY-MM-DD)');
export const hora = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Hora inválida (HH:mm)');
export const instante = z.coerce.date();
export const INT32_MIN = -2_147_483_648;
export const INT32_MAX = 2_147_483_647;
export const centavos = z
  .number()
  .int('Debe ser un monto en centavos')
  .min(INT32_MIN, 'El monto es menor al límite permitido')
  .max(INT32_MAX, 'El monto excede el límite permitido');
export const centavosPositivos = centavos.nonnegative('No puede ser negativo');
export const textoRequerido = (max = 200) => z.string().trim().min(1, 'Requerido').max(max);
export const motivo = textoRequerido(500);
export const paginacion = z.object({
  cursor: z.string().optional(),
  limite: z.coerce.number().int().min(1).max(200).default(50),
});
